import { DefaultButton, Modal, ProgressIndicator } from "@fluentui/react";
import { Component } from "react";
import { connect } from "react-redux";
import PageOverlay from "../helpers//page-overlay-loader";
import CustomStyles from "../helpers/custom-styles";
import PageHeader from "../helpers/page-header";
import { modalStyles } from "../helpers/styles";

class UserConsent extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
    
    };
  }
  async componentDidMount() {
    this._isMounted = true;
    await this.setStateAsync({
        websiteTemplate: this.props.webTemplateConfigData?.websiteTemplate,
        consentRecord:this.props.userConsentRecord
      });
  }
  setStateAsync = (state) => {
    if (this._isMounted) {
      return new Promise((resolve) => {
        this.setState(state, resolve);
      });
    }
  };

  renderConsentModal = () => {
    return (
      <>
       <Modal
  isOpen={this.props.isConsentModalOpen}
  className={`order-user-consent-modal ${modalStyles.container}`}
  layerProps={{ eventBubblingEnabled: true }}
>
  <div className={`modal-wrapper ${modalStyles.consentBody}`}>
    {/* Sticky Header */}
    <div className={`modal-header-wrapper 
                  ${CustomStyles.getStyle(
                    "primary-background-color",
                    this.state.websiteTemplate
                  )}`}>
      <div className={"font-weight-600 "+"modal-header-text"}>
        {this.state.consentRecord?.consentTitle}
      </div>
      <PageOverlay hidden={!this.state.isFormDataSubmitted} />
      <ProgressIndicator
        progressHidden={!this.state.isFormDataSubmitted}
        className="modal-header-frame-progress-indicator"
      />
      {!this.state.isFormDataSubmitted && (
        <div className="modal-frame-separator"></div>
      )}
    </div>

    {/* Scrollable Content */}
    <div className={`modal-content ${modalStyles.content}`}>
      <div className="m-l-5">
        <div
          dangerouslySetInnerHTML={{
            __html: this.state.consentRecord?.consentInformation,
          }}
        />
      </div>
    </div>

    {/* Sticky Footer */}
    <div className={`modal-footer-wrapper  ${modalStyles.content}`}>
    
      <div className="modal-form-actions">
        <DefaultButton
        primary
          text={"Accept"}
          className="page-button-primary m-r-10"
          onClick={async () => {
            await this.props.handleConsentAccept();
          }}
        />
        <DefaultButton
          text={"Reject"}
          className="page-button-primary m-r-10"
          onClick={async () => {
            await this.props.handleConsentReject();
          }}
        />
      </div>
    </div>
  </div>
</Modal>

      </>
    );
  };

  render() {
    return <><div id="spp-page-container">
    <div className="page-header-container">
      <PageHeader
        styleSettings={{ wrapperClassName: "page-main-header-nowrap" }}
        displaySettings={{
          showPageTitle: true,
          showListSearch: false,
          showPageToolbar: true,
        }}
        elementSettings={{
          pageToolbar: {
            feedback: {
              displayStatus: true,
            },
            proxyAccount: {
              displayStatus: false,
              disableStatus: false,
            },
          },
        }}
      />      </div></div>{this.renderConsentModal()}</>;
  }
}
const mapStateToProps = (state) => ({
    
    webTemplateConfigData: state.generalStore.webTemplateConfigData,
   
  
  });
  
  const mapActionToProps = {
    
  };
  
  export default connect(mapStateToProps, mapActionToProps)(UserConsent);
